import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ChartsOverview from "./ChartsOverview";
import SectorMaterialsList from "./SectorMaterialsList";
import ChartsPage from "./ChartsPage";

const ChartsModule = () => {
  return (
    <Routes>
      <Route index element={<ChartsOverview />} />
      <Route path="sector/:sectorId" element={<SectorMaterialsList />} />
      <Route path="material/:materialId" element={<ChartsPage />} />

      {/* Development shortcut (remove in production) */}
      <Route path="dev" element={<Navigate to="/charts/material/MAT_7" replace />} />
    </Routes>
  );
};

export default ChartsModule;
